import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-conceito-justificativa-dialog',
  templateUrl: './conceito-justificativa-dialog.component.html',
})
export class ConceitoJustificativaDialogComponent {
  justificativa: string = ''
  descricaoJustificativa: string = ''

  constructor(
    public dialogRef: MatDialogRef<ConceitoJustificativaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { nome: string; nomeSocial?: string; itemEdital?: string }
  ) {}

  get itemEdital(): string {
    return this.data.itemEdital || '11.7'
  }

  confirmar() {
    let textoFinal = ''
    
    if (this.justificativa === 'IV') {
      textoFinal = `IV- critério de desempate específico do edital da unidade, conforme item ${this.itemEdital} - IV.\n` + this.descricaoJustificativa.trim()
    } else {
      textoFinal = this.justificativa
    }
    
    this.dialogRef.close(textoFinal)
  }

  cancelar() {
    this.dialogRef.close()
  }
}
